import { EnumsInterface } from "@/interfaces/EnumsInterface";

const CaseAssessmentStatus:EnumsInterface[] = [
    {id: 0, value: 0, label: "Yes"},
    {id: 1, value: 1, label: "No"},
    {id: 2, value: 2, label: "Unknown"},
]

export default CaseAssessmentStatus